import { observer } from 'mobx-react-lite';
import { Redirect } from 'react-router-dom';
import { SettingsScoringModelStore as store } from 'src/stores/SettingsStores/SettingsScoringModelStore/SettingsScoringModelStore';

type Props = { basePath: string };

export const ScoringModelDefaultRedirect = observer(({ basePath }: Props) => {
    if (!store?.list?.length) {
        return null;
    }

    return <Redirect to={`${basePath}/${store.list[0].id}`} />;
});
